<script setup>
import {useBaseStore} from "~/stores/base";
import {useProductStore} from "~/stores/product";
import {Delete, Loading} from "@element-plus/icons-vue";
import {globalShare} from "~/utils/common";
import ModalVoteDeleteConfirm from "~/components/product/ModalVoteDeleteConfirm.vue";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits(["close", "see-all"])

/** props **/
const props = defineProps({})

/** data **/
const currentIndex = ref(0)
const isAskMoreLoading = ref(false)
const isShowModalDeleteConfirm = ref(false)
const popoverActive = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const voteData = computed(() => useProductStore().getterVoteData)
const voteList = computed(() => {
  switch (currentIndex.value) {
    case 0:
      return voteData.value.allItems
    case 1:
      return voteData.value.likesItems
    case 2:
      return voteData.value.neutralItems
    case 3:
      return voteData.value.dislikeItems
  }
})
const productId = computed(() => route.params.slug[0])
const query = computed(() => route.query)

/** watch **/

/** methods **/
const tabSelect = (index) => {
  currentIndex.value = index
}
const handleAskMore = async () => {
  if (isAskMoreLoading.value) return
  isAskMoreLoading.value = true
  emits("close")
  /** 打开的是投票窗口 **/
  useProductStore().updateIsVote(true)
  await globalShare({resourceId: productId.value, resourceType: "vote"})
  isAskMoreLoading.value = false
}
const handleSeeAll = async () => {
  emits('see-all')
}
const handleDelete = async () => {
  isShowModalDeleteConfirm.value = true
}
const handleDeleteConfirm = async () => {
  isShowModalDeleteConfirm.value = false
  emits("close")
}

/** lifecycle **/

</script>

<template>
  <div class="slide-current-product-vote-result-mobile" v-if="isMobile">
    <div class="product">
      <div class="left">
        <img :src="voteData.productInfo.mainImage.url" alt="img">
      </div>
      <div class="right">
        <div class="name">{{ voteData.productInfo.productName }}</div>
        <div class="price">{{ voteData.productInfo.currency }}{{ voteData.productInfo.price }}</div>
      </div>

      <!-- option -->
      <el-popover
        placement="bottom-end"
        popper-style="padding: 5px 10px;"
        trigger="click"
        v-model:visible="popoverActive"
      >
        <template #reference>
          <div class="option" :class="{popoverActive}">
            <img src="@/assets/img/icon-dots-vertical.svg" alt="dots">
          </div>
        </template>
        <template #default>
          <div class="btn-text-secondary btn-option" @click="handleDelete">
            <el-icon color="#292929" size="16">
              <Delete/>
            </el-icon>
            <span>Delete Vote</span>
          </div>
        </template>
      </el-popover>
    </div>
    <div class="tabs">
      <div class="tab all" :class="{active: currentIndex === 0}" @click="tabSelect(0)">All ({{
          voteData.allItems.length
        }})
      </div>
      <div class="tab like" :class="{active: currentIndex === 1}" @click="tabSelect(1)"><img src="@/assets/img/icon-like.png" alt="like"> ({{voteData.likesItems.length }})</div>
      <div class="tab neutral" :class="{active: currentIndex === 2}" @click="tabSelect(2)"><img src="@/assets/img/icon-half-like.png" alt="like"> ({{ voteData.neutralItems.length }})</div>
      <div class="tab dislike" :class="{active: currentIndex === 3}" @click="tabSelect(3)"><img src="@/assets/img/icon-unlike.png" alt="like"> ({{ voteData.dislikeItems.length }})</div>
    </div>
    <div class="tab-content" v-if="voteList.length">
      <div class="vote" v-for="(item, index) in voteList" :key="index">
        <div class="avatar" :style="{backgroundColor: item.avatarBg}">
          {{ item.avatarName }}
          <div class="badge" v-if="item.optionLabel === 1"><img src="@/assets/img/icon-like.png" alt="like"></div>
          <div class="badge" v-if="item.optionLabel === 2"><img src="@/assets/img/icon-half-like.png" alt="like"></div>
          <div class="badge" v-if="item.optionLabel === 3"><img src="@/assets/img/icon-unlike.png" alt="like"></div>
        </div>
        <div class="info">
          <div class="name">{{ item.nickname }}</div>
          <div class="text">{{ item.descriptionText }}</div>
        </div>
      </div>
    </div>
    <div class="tab-content empty" v-else>
      No votes yet. Please share again
    </div>
    <div class="footer">
      <div class="btn-text-secondary" :class="{'disabled': isAskMoreLoading}" @click="handleAskMore">
        <el-icon v-if="isAskMoreLoading" class="is-loading" color="#D6D6D6">
          <Loading/>
        </el-icon>
        <span>Ask more friends</span>
      </div>
      <div class="btn-text-secondary" :class="{'disabled': false}" @click="handleSeeAll">
        <el-icon v-if="false" class="is-loading" color="#D6D6D6">
          <Loading/>
        </el-icon>
        <span>See all items your friends voted on</span>
      </div>
    </div>
  </div>
  <div class="slide-current-product-vote-result-desktop" v-else>
    <div class="product">
      <div class="left">
        <img :src="voteData.productInfo.mainImage.url" alt="img">
      </div>
      <div class="right">
        <div class="name">{{ voteData.productInfo.productName }}</div>
        <div class="price">{{ voteData.productInfo.currency }}{{ voteData.productInfo.price }}</div>
      </div>

      <!-- option -->
      <el-popover
        placement="bottom-end"
        popper-style="padding: 5px 10px;"
        trigger="click"
        v-model:visible="popoverActive"
      >
        <template #reference>
          <div class="option" :class="{popoverActive}">
            <img src="@/assets/img/icon-dots-vertical.svg" alt="dots">
          </div>
        </template>
        <template #default>
          <div class="btn-text-secondary btn-option" @click="handleDelete">
            <el-icon color="#292929" size="16">
              <Delete/>
            </el-icon>
            <span>Delete Vote</span>
          </div>
        </template>
      </el-popover>
    </div>
    <div class="tabs">
      <div class="tab all" :class="{active: currentIndex === 0}" @click="tabSelect(0)">All ({{
          voteData.allItems.length
        }})
      </div>
      <div class="tab like" :class="{active: currentIndex === 1}" @click="tabSelect(1)"><img src="@/assets/img/icon-like.png" alt="like"> ({{voteData.likesItems.length }})</div>
      <div class="tab neutral" :class="{active: currentIndex === 2}" @click="tabSelect(2)"><img src="@/assets/img/icon-half-like.png" alt="like"> ({{ voteData.neutralItems.length }})</div>
      <div class="tab dislike" :class="{active: currentIndex === 3}" @click="tabSelect(3)"><img src="@/assets/img/icon-unlike.png" alt="like"> ({{ voteData.dislikeItems.length }})</div>
    </div>
    <div class="tab-content" v-if="voteList.length">
      <div class="vote" v-for="(item, index) in voteList" :key="index">
        <div class="avatar" :style="{backgroundColor: item.avatarBg}">
          {{ item.avatarName }}
          <div class="badge" v-if="item.optionLabel === 1"><img src="@/assets/img/icon-like.png" alt="like"></div>
          <div class="badge" v-if="item.optionLabel === 2"><img src="@/assets/img/icon-half-like.png" alt="like"></div>
          <div class="badge" v-if="item.optionLabel === 3"><img src="@/assets/img/icon-unlike.png" alt="like"></div>
        </div>
        <div class="info">
          <div class="name">{{ item.nickname }}</div>
          <div class="text">{{ item.descriptionText }}</div>
        </div>
      </div>
    </div>
    <div class="tab-content empty" v-else>
      No votes yet. Please share again
    </div>
    <div class="footer">
      <div class="btn-text-secondary" :class="{'disabled': isAskMoreLoading}" @click="handleAskMore">
        <el-icon v-if="isAskMoreLoading" class="is-loading" color="#D6D6D6">
          <Loading/>
        </el-icon>
        <span>Ask more friends</span>
      </div>
      <div class="btn-text-secondary" :class="{'disabled': false}" @click="handleSeeAll">
        <el-icon v-if="false" class="is-loading" color="#D6D6D6">
          <Loading/>
        </el-icon>
        <span>See all items your friends voted on</span>
      </div>
    </div>
  </div>
  <modal-vote-delete-confirm
    :open="isShowModalDeleteConfirm"
    :product-id="voteData.productInfo.productId"
    :vote-id="query.voteId"
    @close="isShowModalDeleteConfirm = false"
    @confirm="handleDeleteConfirm"
  />
</template>

<style scoped lang="scss">
.btn-option {
  margin: 0 auto;
  width: fit-content;
  padding: 5px 10px;
}
</style>

<style scoped lang="scss">
@import "src/assets/config";

.slide-current-product-vote-result-mobile {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  .product {
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;

    .left {
      display: flex;

      img {
        width: 100px;
        height: 140px;
      }
    }

    .right {
      width: 68%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;

      .name {
        font-family: "TWK Lausanne";
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.056px;
      }

      .price {
        font-family: "TWK Lausanne";
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px; /* 150% */
        text-transform: uppercase;
      }
    }

    .option {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      border: .5px transparent solid;
    }

    .popoverActive {
      border: .5px $color-BNTO-beige-dark solid;
    }
  }

  .tabs {
    margin: 8px 0;
    display: flex;
    align-items: center;
    gap: 24px;
    border-bottom: 1px solid $color-gray-200;

    .tab {
      border-bottom: 2px solid;
      border-bottom-color: transparent;
      cursor: pointer;
      padding: 8px 0;

      text-align: center;
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 19px; /* 135.714% */
      position: relative;
      bottom: -1px;

      cursor: pointer;

      display: flex;
      align-items: center;
      gap: 2px;

      &.active {
        border-bottom-color: $color-BNTO-beige-dark;
      }

      img {
        width: 20px;
        height: 18px;
      }
    }
  }

  .tab-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 30px;

    .vote {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 18px;

      .avatar {
        flex-shrink: 0;
        width: 52px;
        height: 52px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        color: $color-BNTO-beige-dark;
        text-align: center;
        font-family: "TWK Lausanne";
        font-size: 22px;
        font-style: normal;
        font-weight: 650;
        line-height: 20px; /* 90.909% */

        position: relative;

        .badge {
          width: 26px;
          height: 23px;
          position: absolute;
          right: -10px;
          bottom: 0;

          display: flex;

          img {
            width: 26px;
            height: 23px;
          }
        }
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .name {
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 19px; /* 135.714% */
        }

        .text {
          width: 273px;
          word-break: break-all;
          white-space: wrap;
          color: $color-gray-500;

          font-family: "TWK Lausanne";
          font-size: 12px;
          font-style: normal;
          font-weight: 300;
          line-height: 12px; /* 100% */
        }
      }
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;

    color: $color-gray-500;
    text-align: center;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 12px; /* 85.714% */
  }

  .footer {
    width: 100%;
    position: sticky;
    bottom: 0;
    padding: 16px 0 32px 0;

    border-top: 0.5px solid $color-BNTO-beige-dark;

    display: flex;
    flex-direction: column;
    gap: 12px;

    div {
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 12px; /* 85.714% */

      width: fit-content;
    }
  }
}

.slide-current-product-vote-result-desktop {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  .product {
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;

    .left {
      display: flex;

      img {
        width: 100px;
        height: 140px;
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;

      .name {
        font-family: "TWK Lausanne";
        font-size: 14px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.056px;
      }

      .price {
        font-family: "TWK Lausanne";
        font-size: 12px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px; /* 150% */
        text-transform: uppercase;
      }
    }

    .option {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 0;
      border: .5px transparent solid;
    }

    .popoverActive {
      border: .5px $color-BNTO-beige-dark solid;
    }
  }

  .tabs {
    margin: 8px 0;
    display: flex;
    align-items: center;
    gap: 24px;
    border-bottom: 1px solid $color-gray-200;

    .tab {
      border-bottom: 2px solid;
      border-bottom-color: transparent;
      cursor: pointer;
      padding: 8px 0;

      text-align: center;
      font-family: "TWK Lausanne";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 19px; /* 135.714% */
      position: relative;
      bottom: -1px;

      cursor: pointer;

      display: flex;
      align-items: center;
      gap: 2px;

      &.active {
        border-bottom-color: $color-BNTO-beige-dark;
      }

      img {
        width: 20px;
        height: 18px;
      }
    }
  }

  .tab-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 30px;

    .vote {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 18px;

      .avatar {
        flex-shrink: 0;
        width: 52px;
        height: 52px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        color: $color-BNTO-beige-dark;
        text-align: center;
        font-family: "TWK Lausanne";
        font-size: 22px;
        font-style: normal;
        font-weight: 650;
        line-height: 20px; /* 90.909% */

        position: relative;

        .badge {
          width: 26px;
          height: 23px;
          position: absolute;
          right: -10px;
          bottom: 0;

          display: flex;

          img {
            width: 26px;
            height: 23px;
          }
        }
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .name {
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 19px; /* 135.714% */
        }

        .text {
          width: 273px;
          word-break: break-all;
          white-space: wrap;
          color: $color-gray-500;

          font-family: "TWK Lausanne";
          font-size: 12px;
          font-style: normal;
          font-weight: 300;
          line-height: 12px; /* 100% */
        }
      }
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;

    color: $color-gray-500;
    text-align: center;
    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 12px; /* 85.714% */
  }

  .footer {
    width: 100%;
    position: sticky;
    bottom: 0;
    padding: 16px 0 32px 0;

    border-top: 0.5px solid $color-BNTO-beige-dark;

    display: flex;
    flex-direction: column;
    gap: 12px;

    div {
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: 12px; /* 85.714% */

      width: fit-content;
    }
  }
}
</style>
